'use strict';

var _ = require('lodash');
var EventEmitter = require('events').EventEmitter;

function EventUtil ($rootScope, $timeout) {

  function EventEmitter2 () {
    EventEmitter.call(this);
  }
  
  EventEmitter2.prototype = _.create(EventEmitter.prototype, {
    constructor: EventEmitter2,
    __super__: EventEmitter.prototype
  });

  EventEmitter2.prototype.off = EventEmitter.prototype.removeListener;

  /**
   * Improved addEventListener method specifically for Angular.
   * 
   * This allows an optional scope to be passed in. If scope is set then a 
   * '$destroy' callback will be attached so that the event handler is automatically 
   * detached in the event the scope is destroyed. This is necessary to prevent 
   * memory leaks.
   * 
   * @param  {String} eventname
   * @param  {Function} handler
   * @param  {Object} scope Angular scope
   */
  EventEmitter2.prototype.on = function (eventname, handler, scope) {
    if (scope) {
      scope.$on('$destroy', function () {
        console.info('Scope %d destroyed... unregister EventEmitter listeners', scope.$id);
        this.off(eventname, handler);
      }.bind(this));
    } 

    EventEmitter.prototype.addListener.call(this, eventname, handler);
    
    return function () {
      this.off(eventname, handler);
    }.bind(this);
  };

  /**
   * Improved emit method.
   *
   * This ensures that the eventname is ALWAYS defined. If "undefined" is passed 
   * to the original method js typecasts "undefined" to a string and emit the 
   * event, potentially causing some difficult to track down bugs.
   */
  EventEmitter2.prototype.emit = function () {
    if (arguments[0] === undefined) {
      throw new Error('Eventname cannot be undefined');
    }

    var args = arguments;
    $rootScope.$applyAsync(function () {
      this.__super__.emit.apply(this, args);
    }.bind(this));
  };

  EventEmitter2.prototype.emitNext = function () {
    console.warn('DEPRECATED: Same as `emit` now');
    this.emit.apply(this, arguments);
  };

  this.EventEmitter = EventEmitter2;
}

EventUtil.$inject = ['$rootScope', '$timeout'];
module.exports = EventUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/lib/Event.js